import { useState } from "react";
import { Phone, Mail, ArrowUpRight, Check, Copy } from "lucide-react";
import { WhatsAppIcon, WHATSAPP_URL } from "./WhatsAppIcon";
import Reveal from "./Reveal";

export const Contact = () => {
    const [copied, setCopied] = useState(false);

    const copyEmail = async () => {
        try {
            await navigator.clipboard.writeText("serviziamicielena@gmail.com");
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (e) {
            setCopied(false);
        }
    };

    return (
        <section id="contatti" className="rounded-t-[3rem] bg-ink text-cream">
            <div className="mx-auto max-w-7xl px-5 lg:px-10 py-24 lg:py-32">
                <Reveal>
                    <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-sage">
                        Contatti
                    </p>
                    <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight">
                        Parliamone,
                        <br />
                        <em className="italic text-terracotta">come amici.</em>
                    </h2>
                    <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-cream/70">
                        Raccontaci di cosa hai bisogno: al telefono o via mail,
                        con calma e senza impegno. Lavoriamo in tutta
                        l'Emilia-Romagna.
                    </p>
                </Reveal>

                <div className="mt-16 lg:mt-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
                    <Reveal y={40}>
                        <div data-testid="contact-phone-card" className="group">
                            <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-cream/50">
                                <Phone className="h-4 w-4 text-terracotta" />
                                Telefono
                            </p>
                            <a
                                href="tel:+393522553391"
                                data-testid="contact-phone"
                                className="link-sweep inline-flex items-baseline gap-3 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream"
                            >
                                352 255 3391
                                <ArrowUpRight className="h-8 w-8 self-center text-terracotta transition-transform duration-300 group-hover:rotate-45" />
                            </a>
                        </div>
                    </Reveal>

                    <Reveal y={40} delay={0.12}>
                        <div data-testid="contact-email-card" className="group">
                            <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-cream/50">
                                <Mail className="h-4 w-4 text-terracotta" />
                                Email
                            </p>
                            <a
                                href="mailto:serviziamicielena@gmail.com"
                                data-testid="contact-email"
                                className="link-sweep inline-flex items-baseline gap-3 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-cream break-all"
                            >
                                serviziamicielena
                                <br className="hidden sm:block" />
                                @gmail.com
                                <ArrowUpRight className="h-8 w-8 self-center text-terracotta transition-transform duration-300 group-hover:rotate-45" />
                            </a>
                            <div className="mt-6">
                                <button
                                    onClick={copyEmail}
                                    data-testid="copy-email-button"
                                    className="inline-flex items-center gap-2 rounded-full border border-cream/25 px-5 py-2.5 text-sm font-bold text-cream/90 transition-all duration-300 hover:bg-cream/10 hover:-translate-y-0.5"
                                >
                                    {copied ? (
                                        <>
                                            <Check className="h-4 w-4 text-sage" />
                                            Email copiata
                                        </>
                                    ) : (
                                        <>
                                            <Copy className="h-4 w-4" />
                                            Copia email
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.2}>
                    <div className="mt-16 lg:mt-24 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 rounded-[28px] border border-cream/15 p-8 lg:p-10">
                    <div>
                        <p className="font-serif text-2xl sm:text-3xl font-light italic">
                            Ogni giornata è più leggera, <span className="text-terracotta">in due.</span>
                        </p>
                        <p
                            data-testid="contact-opening-hours"
                            className="mt-3 text-sm font-semibold uppercase tracking-wider text-cream"
                        >
                            Lun–Ven 07:00–18:00 · Sabato e domenica chiusi
                        </p>
                    </div>
                    <div className="flex flex-wrap shrink-0 gap-3">
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-cta-whatsapp"
                                className="inline-flex items-center gap-3 rounded-full border border-cream/25 px-7 py-4 text-base font-bold text-cream transition-all duration-300 hover:bg-[#25D366] hover:border-[#25D366] hover:text-ink hover:-translate-y-0.5"
                            >
                                <WhatsAppIcon className="h-5 w-5 text-[#25D366] transition-colors duration-300 group-hover:text-ink" />
                                WhatsApp
                            </a>
                            <a
                                href="tel:+393522553391"
                                data-testid="contact-cta-call"
                                className="inline-flex items-center gap-3 rounded-full bg-terracotta px-7 py-4 text-base font-bold text-cream transition-all duration-300 hover:bg-terracotta-dark hover:-translate-y-0.5 hover:shadow-xl hover:shadow-terracotta/30"
                            >
                                <Phone className="h-5 w-5" />
                                Chiama ora
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Contact;
